import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import MDBox from "components/MDBox";
import VehicleCard from "./vehicleCard";
import { AccountsContext } from "context/AccountsContext";
import axios from "axios";
import { cachementreportendpoint } from "config";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import MDButton from "components/MDButton";

function VehicleList({ onJourneysChange }) {
  const { fetchThings, things } = useContext(AccountsContext);
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [selectedJourneys, setSelectedJourneys] = useState({});
  
  // State to control when to show the dropdown
  const [isAddingNew, setIsAddingNew] = useState(true);

  useEffect(() => {
    fetchThings();
  }, []);

  const handleVehicleSelect = async (newValue) => {
    if (!newValue) return;

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${cachementreportendpoint}/${newValue.thingId}?thingId=${newValue.thingId}`,
        {
          headers: {
            "x-dhundhoo-session": token,
          },
        }
      );

      if (response.data?.allWayPoints) {
        const newJourneys = response.data.allWayPoints;
        const updatedVehicles = [
          ...selectedVehicles,
          { ...newValue, journeys: newJourneys },
        ];
        setSelectedVehicles(updatedVehicles);

        const allSelectedJourneys = { ...selectedJourneys };
        newJourneys.forEach((journey) => {
          if (!allSelectedJourneys[journey.journeyId]) {
            allSelectedJourneys[journey.journeyId] = false;
          }
        });

        setSelectedJourneys(allSelectedJourneys);
        onJourneysChange(
          updatedVehicles.flatMap((v) => v.journeys),
          allSelectedJourneys
        );

        // Vehicle select hone ke baad dropdown hide kar do
        setIsAddingNew(false);
      }
    } catch (error) {
      console.error("Error fetching vehicle report:", error);
    }
  };

  const handleCheckboxChange = (journeyId) => {
    setSelectedJourneys((prev) => {
      const newSelectedJourneys = {
        ...prev,
        [journeyId]: !prev[journeyId],
      };
      onJourneysChange(
        selectedVehicles.flatMap((v) => v.journeys),
        newSelectedJourneys
      );
      return newSelectedJourneys;
    });
  };

  const handleRemoveVehicle = (vehicleToRemove) => {
    const updatedVehicles = selectedVehicles.filter(
      (vehicle) => vehicle.thingId !== vehicleToRemove.thingId
    );
    const removedJourneyIds = vehicleToRemove.journeys.map((j) => j.journeyId);
    const updatedSelectedJourneys = { ...selectedJourneys };
    removedJourneyIds.forEach((id) => delete updatedSelectedJourneys[id]);

    setSelectedVehicles(updatedVehicles);
    setSelectedJourneys(updatedSelectedJourneys);
    onJourneysChange(
      updatedVehicles.flatMap((v) => v.journeys),
      updatedSelectedJourneys
    );

    // Agar koi vehicle nahi bacha, toh dropdown wapas dikhao
    if (updatedVehicles.length === 0) {
      setIsAddingNew(true);
    }
  };

  return (
    <MDBox>
      {/* Show journeys with checkboxes for each selected vehicle */}
      {selectedVehicles.map((vehicle, index) => (
        <Grid container spacing={2} key={vehicle.thingId} mb={2}>
          <Grid item xs={12}>
            <VehicleCard
              title={vehicle.nickName || vehicle.thingId}
              journeys={vehicle.journeys}
              selectedJourneys={selectedJourneys}
              onToggleJourney={handleCheckboxChange}
              onDelete={() => handleRemoveVehicle(vehicle)}
            />
          </Grid>
        </Grid>
      ))}

      {/* Conditional UI: Dropdown OR "Add Another" Button */}
      {isAddingNew ? (
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12}>
            <Autocomplete
              disablePortal
              options={things.filter(
                (thing) => !selectedVehicles.some((v) => v.thingId === thing.thingId)
              ) || []}
              getOptionLabel={(option) => option.nickName || option.thingId}
              value={null}
              onChange={(event, newValue) => handleVehicleSelect(newValue)}
              renderOption={(props, option) => (
                <li
                  {...props}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{option.nickName}</span>
                  <span style={{ color: "#666" }}>{option.thingId}</span>
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search or select vehicle"
                  fullWidth
                  size="small"
                />
              )}
            />
            {/* Optional: Cancel button agar galti se click ho gaya ho */}
            {selectedVehicles.length > 0 && (
              <Button 
                size="small" 
                color="secondary" 
                onClick={() => setIsAddingNew(false)}
                style={{ marginTop: '8px' }}
              >
                Cancel
              </Button>
            )}
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12}>
            <MDButton
              variant="contained"
              // color="primary"
              fullWidth
              startIcon={<Icon>add</Icon>}
              onClick={() => setIsAddingNew(true)}
              style={{ color: 'black', backgroundColor: '#FB8C00' }}
            >
              Add Another Vehicle
            </MDButton>
          </Grid>
        </Grid>
      )}
    </MDBox>
  );
}

VehicleList.propTypes = {
  onJourneysChange: PropTypes.func.isRequired,
};

export default VehicleList;